import GsuiteAuth from '../components/Auth/GsuiteAuth';

export default function (button_id, roleButtons, roleCheckData){
    const buttonRole = roleButtons&&roleButtons[button_id]
    const user_id = GsuiteAuth.get('id')
    const user_branch_id = GsuiteAuth.get('user_branch_id')
    //console.log("button role ", button_id, buttonRole&&buttonRole.button_flag)
    //console.log('roleCheckData', roleCheckData)
    ////　0 操作不可 1:全操作可　2:支店分のみ操作可　3:自担当のみ操作可
    switch(buttonRole&&buttonRole.button_flag){
        case 1:
//            console.log('allways usable', button_id, false)
            return false
        case 2:
            const dataUserBranchId = roleCheckData && (roleCheckData.user_branch_id || roleCheckData.user_branch)
//            console.log('branch check', button_id, `!(${dataUserBranchId} == ${user_branch_id})`,!(dataUserBranchId==user_branch_id))
            return !(dataUserBranchId && dataUserBranchId==user_branch_id)
        case 3:
            const dataUserId = roleCheckData && ((roleCheckData.request && roleCheckData.request.onsite_survey_account) || roleCheckData.onsite_survey_account)
 //           console.log('user check', button_id, !(dataUserId==user_id))
            return !(dataUserId && dataUserId==user_id)
        default:
            return true
    }
}